module.exports = __webpack_public_path__ + "img/bag-tag-neotag-banner.96d15322.png";